/**
 * @generated SignedSource<<d86e44ca8e1dbc20c81ca53dafbfe97d>>
 * @relayHash fadb2dc3dc71275bfa19f63a8dbd689c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 455f6821a5570808c0f947b10410f4e6a7366ca3daee497869dd6205801210cd

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { main_getIssueTransitionByIdRootQuery } from './main_getIssueTransitionByIdRootQuery.graphql';

import isFCFAccessNarrowingEnabled_provider from '@atlassian/jira-relay-provider/src/fcf-its-with-access-narrowing.relayprovider';
import includeUserAccessEnabledForge_provider from '@atlassian/jira-relay-provider/src/forge-query-include-user-access-enabled.relayprovider';
import includeUserAccess_provider from '@atlassian/jira-relay-provider/src/forge-query-include-user-access.relayprovider';
import isNikeChinMigrateMultiSelectEditViewDeprecatedEnabled_provider from '@atlassian/jira-relay-provider/src/nike-chin-migrate-multi-select-edit-view-deprecated.relayprovider';

const node: PreloadableConcreteRequest<main_getIssueTransitionByIdRootQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "455f6821a5570808c0f947b10410f4e6a7366ca3daee497869dd6205801210cd",
    "metadata": {},
    "name": "main_getIssueTransitionByIdRootQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcforgequeryincludeuseraccessrelayprovider": includeUserAccess_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcfcfitswithaccessnarrowingrelayprovider": isFCFAccessNarrowingEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcforgequeryincludeuseraccessenabledrelayprovider": includeUserAccessEnabledForge_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcnikechinmigratemultiselecteditviewdeprecatedrelayprovider": isNikeChinMigrateMultiSelectEditViewDeprecatedEnabled_provider
    }
  }
};

export default node;
